var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bizservice)?_c('v-card',{attrs:{"flat":""}},[_c('v-toolbar',{attrs:{"flat":"","dense":""}},[_c('div',{staticClass:"subtitle-2"},[_vm._v("7Shifts Integration")])]),_c('v-img',{staticClass:"my-3",attrs:{"src":_vm.icon,"height":"50px","contain":""}}),(_vm.established)?_c('Integrated',{ref:"integrated"}):_c('StartForm')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }